import { css } from "@emotion/react";
import React from "react";
import { FaBomb } from "react-icons/fa";

export default function Fatal() {
    return (
        <div
            css={css`
                padding: 8rem 0;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
            `}
        >
            <FaBomb size="6rem" />
            <h1>ERROR</h1>
            <a href="">try again?</a>
        </div>
    );
}
